import script from "./PlayerCharacter.vue?vue&type=script&lang=js"
export * from "./PlayerCharacter.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__